module.exports = __webpack_public_path__ + "img/feedback.5b2eea9a.jpg";